import ColumnName from './ColumnName';
import ColumnTypeData from './ColumnType';

class DataTableHeading {
  constructor(columnName, colType, cssClass, isDimension, aggregation) {
    this._columnName = columnName; // ColumnName obj
    this._columnType = colType; // ColumnType obj
    this._cssClass = cssClass; // optional string, if data table heading should have an extra css class
    this._isDimension = isDimension; // true if was a dimension in a summarize step
    this._aggregation = aggregation; // EnumDateTimeAggregation
  }

  static fromColumn(c) {
    return new DataTableHeading(c.name(), c.type(), null);
  }

  static fromServer(h) {
    return new DataTableHeading(
      ColumnName.build(h._columnName),
      ColumnTypeData.build(h._columnType),
      h._cssClass,
      h._isDimension,
      h._aggregation,
    );
  }

  columnName() {
    return this._columnName;
  }

  columnType() {
    return this._columnType;
  }

  cssClass() {
    return this._cssClass;
  }

  isDimension() {
    return this._isDimension;
  }

  aggregation() {
    return this._aggregation;
  }
}

export default DataTableHeading;
